









import { defineComponent } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';

const CommonDotLevels = defineComponent({
  setup(props) {
    const { distanceTypeToColor, distanceTypeToLevel } = useDeliveryAreaCode();
    const color = distanceTypeToColor(props.distance);
    const level = distanceTypeToLevel(props.distance);
    return {
      color,
      level,
    };
  },
  props: {
    distance: {
      type: String,
      default: '',
    },
  },
});

export default CommonDotLevels;
